import { makeStyles } from "@mui/styles";
import colorSchemes from "../../../constants/colorSchemes";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: "8rem",
    marginBottom: "4rem",
    [theme.breakpoints.down("md")]: {
      marginTop: "12rem",
    },
  },
  heading: {
    textAlign: "center",
    fontSize: "20px !important",
    fontWeight: "600 !important",
    color: `${colorSchemes.primaryColor} !important`,
  },
  subHeading: {
    textAlign: "center",
    color: "#7E8184",
    fontSize: "14px !important",
    margin: "0.5em 0em 2.5em 0em !important",
  },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "2em 1.5em",
    borderRadius: "4px !important",
    border: "1px solid #E5E5E5",
    boxShadow: "0px 0px 66px -15px #ccc !important",
    [theme.breakpoints.down("md")]: {
      marginBottom: "1.5em",
    },
  },
  icon: {
    color: colorSchemes.primaryColor,
    fontSize: "40px !important",
  },
  cardTitle: {
    fontSize: "18px !important",
    fontWeight: "600 !important",
    margin: "0.5em 0em 0.3em 0em !important",
  },
  cardText: {
    color: "#7E8184",
    fontSize: "14px !important",
  },
  list: {
    listStyle: "none",
    padding: "0px",
    margin: "1.5em 0em 2em 0em",
    flexGrow: 1,
  },
  listItem: {
    color: "#3F4043",
    fontSize: "14px",
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "0.75em",
  },
  checkIcon: {
    color: colorSchemes.primaryColor,
    fontSize: "18px !important",
    marginRight: "0.5em",
  },
  button: {
    borderRadius: "0em !important",
    backgroundColor: `${colorSchemes.primaryColor} !important`,
    color: "#fff !important",
  },
  signInText: {
    textAlign: "center",
    marginTop: "2.5em !important",
    fontSize: "14px !important",
    color: "#7E8184",
  },
}));

export default useStyles;
